module.exports = {
	"app.intro": " ",
	"app.footer-info": " ",
	"app.footer-copyright": "© Copyright&nbsp;",
	"app.footer-sign": "&nbsp;MendozaFiduciaria – Todos los derechos reservados",
	"app.min_specs_headline": "",
	"app.min_specs_subheading": "",
	"app.min_specs": "",
	"app.how_it_works": "",
	"app.step_rejected": "",
	"app.step_rejected_investment": "",
	"app.step_rejected_investment_contact": "",
	"app.faq1": "",
	"app.faq2": "",
	"app.step_main": "<h3>Completá el formulario con tus datos personales</h3>",
	"app.step_start": "<h4>¡Bienvenido! <br> Estás por comenzar tu solicitud de crédito fiscal on line.</h4>",
	"app.step_ddjj": "<h4><p>⚠️ Aviso Importante</p></h4><p>Antes de iniciar el proceso deberá: </p><h4><p>1- Tener regularizada su situación en ATM </p></h4><h4><p>2- Realizar la transferencia del crédito fiscal</p></h4><p>Por favor <a href=\"https://mendozafiduciaria.com/wp-content/uploads/2022/11/TERMINOS-Y-CONDICIONES.pdf\" target=\"_blank\">abrir, leer y aceptar</a> los Términos y Condiciones de Mendoza Fiduciaria</p>",
	"app.step_startup_info": "",
	"app.step_guarantor": "",
	"app.step_guarantor_info": "<h3>Ingresá los datos del Garante</h3>",
	"app.step_surety": "",
	"app.step_loan_reason": "",
	"app.step_loan_type": "",
	"app.step_loan_type_credit": "",
	"app.step_loan_type_investment": "",
	"app.step_company_type": "",
	"app.step_loan_description": "",
	"app.step_pry_address": "",
	"app.step_pry_rol": "",
	"app.step_general_warranty": "",
	"app.step_fields": "",
	"app.step_ca_warranty": "<h3>Elegí el tipo de garantía</h3>",
	"app.step_attorney_info": "",
	"app.step_guarantor_type_bond": " ",
	"app.step_sms": "<h3>Hemos enviado un SMS a tu celular, por favor ingresá ese código para continuar</h3><p>(el sms puede demorar unos segundos)</p>",
	"app.step_sms_whatsapp_number": "5492612414365",
	"app.step_sms_whatsapp_text": "261-2414-365",
	"app.step_sms_whatsapp_label": "261-2414-365",
	"app.step_members_os": "<h3>Te pedimos que completes los datos de los miembros titulares del directorio u órgano similar.</h3>",
	"app.step_members_ss": "<h3>Te pedimos que completes los datos de cada uno de los socios.</h3>",
	"app.whatsapp_timetable": "<p class=\"pd-opening-hours\">Lunes a Viernes de 08:00hs - 14:00hs </p>",
	"app.renaper_step": "A continuación efectuaremos una validación de tu identidad a través del Registro Nacional de las Personas (RENAPER)",
	"app.renaper_step_form": "Este botón te llevará a la página del RENAPER, una vez que hayamos validado tu idendidad podrás seguir con tu solicitud en nuestra web.",
	"app.step_cbu": "<h3>Completá la información que corresponda</h3><p>Ingresá el CBU donde recibirá lo transferido</p>",
	"app.step_address": "<h3>Ingresá tu domicilio especial</h3>",
	"app.step_confirm_address": "<h3>¿El solicitante tiene domicilio real en Mendoza?</h3>",
	"app.step_has_property": "<h3>¿Es titular de un inmueble?</h3>",
	"app.step_incomes": "<p>Por favor ingresá la información de tu último recibo de sueldo o documentación de ingresos más reciente.</p>",
	"app.step_personal_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
	"app.step_service_info": "<p>Por favor ingresá tu información personal y los servicios que tenés disponible en tu domicilio.</p>",
	"app.step_job_info": "<p>Por favor ingresá la información de tus datos laborales.</p>",
	"app.step_email": "<p>Para continuar con tu solicitud por favor ingresá tu correo electrónico.</p>",
	"app.step_upload_info": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
	"app.step_product": "<h3><b>Felicitaciones</b> estás <b>Pre-APROBADO!</b></h3><p>Para continuar, elegí el monto y las cuotas a solicitar:</p>",
	"app.step_product_label_quota": "cuota",
	"app.step_upload": "<p>Para continuar por favor subí una foto de tu DNI del frente / dorso, 2 servicios y tus últimos 3 bonos de sueldo.</p>",
	"app.step_checkout": "<p>Aceptar estos documentos tienen carácter de declaración jurada.</p>",
	"app.contract_advice": "<p>Por favor, abrir, leer y acordar con Mendoza Fiduciaria</p>",
	"app.step_checkout_requested_amount": "Monto del Préstamo:",
	"app.step_checkout_quota_amount": "Valor de la cuota:",
	"app.step_checkout_requested_quotas": "Cuotas:",
	"app.step_checkout_other_costs": "Costos Administrativos:",
	"app.step_checkout_first_payment_date": "Pago de la cuota:",
	"app.step_checkout_first_payment_date_info": "Del 1 al 10 de cada mes.",
	"app.step_checkout_info": "El pago se realiza via Débito Automático desde la cuenta donde se depositó el préstamo.",
	"app.step_email_verification": "<h3><b>Para finalizar con tu solicitud haz clic en el enlace que te enviamos a tu correo electrónico</b></h3>",
	"app.disapproved": "<h3><b>Por el momento no puede continuar la solicitud. Por favor, revise su situación.</b></h3>",
	"app.step_documents": "<h3><p>Por favor ingresá la documentación solicitada.</p></h3>",
	"app.step_deposit": "<h3><p>Por favor indícanos la modalidad de depósito.</p></h3>",
	"app.step_credit_card": "<h3><p>Por favor ingresá los datos solicitados de tu tarjeta.</p></h3>",
	"app.step_congratulations_whatsapp_number": "5492612414365",
	"app.step_congratulations_whatsapp_text": "261-2414-365",
	"app.step_congratulations_whatsapp_label": "261-2414-365",
	"app.step_congratulations_title": "<h3><b>Gracias por completar la solicitud online</b></h3><p><b>En breve resolveremos su solicitud</b></p>",
	"app.step_congratulations_info": "<h3>¡Felicitaciones!</h3>",
	"app.step_congratulations_footer": "<p>Puedes comunicarte con nosotros llamando al: </p>",
	"app.step_congratulations_salute": " ",
	"app.step_mza_active": "<h3>Completá la información que corresponda</h3><p>¿Es beneficiario de Mendoza Activa?</p>",
	"app.step_electronic_wallet": "<h3>Completá la información que corresponda</h3><p>Seleccione la billetera electrónica donde posee el credíto fiscal</p>",
	"app.step_amount": "<h3>Completá la información que corresponda</h3><p>Ingresá el monto acceder del crédito fiscal</p>",
	"app.step_amount_info": "<p>El monto que transfirió en este mes a Mendoza Fiduciaria es de</p>",
	"app.disapproved_description": " ",
	"app.greetings_modal": "<h3><b>Gracias por contactarte con nosotros!</b></h3><p> Cualquier duda o consulta que tengas podés comunicarte con nuestro Centro de Atención On Line.</p><p>Saludos!</p>",
	"app.step_available_amount_description": "<p><b>Recordá que el tope mensual es de $125.000</b></p><span>Si transfiere más del tope establecido, será revertido el monto total de la transferencia y deberá reiniciar su solicitud</span>",
	"app.step_available_amount": "Se aprobará el crédito fiscal por el 80% del valor transferido",
	"app.step_lead_amount_info": "<p>El monto otorgado en este mes es de</p>"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/translations/fiduciaria.json
 ** module id = 1000
 ** module chunks = 0
 **/